module.exports = __webpack_public_path__ + "static/tiffany-05-8a29d36a2180212920fbfefb6c7dee59.jpg";